import React from "react";
import './Content.css'
import phoneImage from '../static/iPhone X.png'

const Content = () =>{
    return(
        <div className="body" id="content">
            <div className="content">
                <p className="c-text">Transform Your Digital Future</p>
                <p className="description">Appmend is your trusted technology partner. We provide expert training, custom development, and strategic consultation to help individuals and organizations thrive in the digital age.</p>
                <div className="action-buttons">
                    <button className="cta-button primary" onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}>
                        Explore Services
                    </button>
                    <button className="cta-button secondary" onClick={() => document.getElementById('about').scrollIntoView({ behavior: 'smooth' })}>
                        Learn More
                    </button>
                </div>
            </div>
            <div className="hero-image">
                <img src={phoneImage} alt="Appmend Mobile Apps" className="phone-mockup"/>
            </div>
        </div>
    );
}
export default Content